export default __webpack_public_path__ + "static/media/player.4a5164fb.svg";